import * as Profile from 'app/entities/Profile';
import * as Subscription from 'app/entities/Subscription';

const LEARN_ABOUT_2FA_URL = '/app/settings/security';

export const STATIC_NOTIFICATIONS_STORAGE_KEY = 'staticNotificationsDismissed';

export default [
  {
    type: 'terms-of-service',
    title: "We're updating our Terms of Service",
    isDismissable: true,
    message:
      "We're making some exciting improvements to Zapier, and as a result, we are updating our Terms of Service to reflect these changes.",
    link: '/terms/#updated-tos',
    buttonText: 'Learn More',
    isApplicable: () => true,
  },
  {
    type: 'paths',
    title: 'Try Paths',
    isDismissable: true,
    message:
      'Now you can add conditional logic to your Zaps to run different actions based on conditions you decide.',
    link: '/paths',
    buttonText: 'Learn More',
    isApplicable: () => true,
  },
  {
    type: 'verify',
    title: 'Verify your account',
    message:
      'To help protect your account and ensure your information is correct, please confirm your email address.',
    buttonText: 'Confirm My Email',
    action: profileId => Profile.actions.sendConfirmationEmail(null, profileId),
    isApplicable: profile =>
      !Profile.selectors.isEmailPendingChange(profile) &&
      !Profile.selectors.isEmailConfirmed(profile),
  },
  {
    type: 'consent-marketing-emails',
    title: 'Level Up your Productivity',
    isDismissable: true,
    message:
      'Get expert tips on Zapier features, app updates, and in-depth productivity guides in your inbox.',
    buttonText: 'Subscribe to Emails',
    action: () => Subscription.actions.subscribeToMarketingChannels(),
    isApplicable: profile => !Profile.selectors.isGDPRConsented(profile),
  },
  {
    type: 'subscribe',
    title: 'Be More Efficient',
    isDismissable: true,
    message: 'Get productivity tips and app guides in your inbox.',
    buttonText: 'Subscribe',
    action: () => Subscription.actions.subscribeToBlog(),
    isApplicable: (profile, state) =>
      !Subscription.selectors.all.isSubscribedToBlog(state),
  },
  {
    type: 'enable2fa',
    title: 'Two-Factor Authentication',
    isDismissable: true,
    message:
      'Add an extra layer of security to your account with two-factor authentication (2FA).',
    link: LEARN_ABOUT_2FA_URL,
    iconType: 'lock',
    buttonText: 'Learn More',
    isApplicable: profile => !Profile.selectors.hasEnabled2fa(profile),
  },
  // TODO(ngryman): change the message later to emphasize on the mismatch rather than the new feature
  {
    type: 'timezones',
    title: 'Update your time zone',
    isDismissable: true,
    message:
      "We're now using your Zapier profile's time zone. It seems that your computer's time zone does not match your profile's one.",
    link: '/app/settings/profile',
    iconType: 'clock',
    buttonText: 'Update your profile',
    isApplicable: profile => Profile.selectors.isTimezoneMismatching(profile),
  },
];
